import { useTeamContext } from '../store/contexts/TeamContext';

const useIsUserOnTeam = () => {
  const { availableTeams, loading } = useTeamContext();

  return { isUserOnTeam: !!availableTeams.length, loading };
};

export default useIsUserOnTeam;
